import { useEffect, useState } from "react";
import { useParams } from 'react-router';
import query from "../../../../server/constants.api";
import useFetch from "../../../../server/useFetch";
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import { BasicTable } from '@synergy/table';
import { Flex } from 'antd';
import { Text } from '../../Atomics/Text';

export const RelatedAssetsTable = ({hasRelatedAssets}) => {
    const { t } = useTranslation();
    const { id } = useParams();

    const [rlData, setRlData] = useState(null);
    const { data: relatedLinksData, isLoading: relatedLinksLoading, refetch: refetchRelatedLinks } = useFetch(query.path.relatedLinks, 'getRelatedLinks', { id: id, language: i18next.resolvedLanguage });

    useEffect(() => {
      if (relatedLinksData?.data) {
        setRlData(relatedLinksData?.data);
        hasRelatedAssets(true)
      } else {
        hasRelatedAssets(false)
      }
    }, [relatedLinksData]);
    return (
        <Flex id='Related Assets' className='ant-anchors-content-item' gap={32} vertical="true">
            <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>{t('relatedAssets')}</Text>
            <BasicTable tableId='tableIdTthree' fetchData={rlData} hrefLink={null} language={i18next.resolvedLanguage} />
        </Flex>
    )
}